import { Box } from '@mui/material';
import { ClientStepProps } from '../../types';
import { JSX } from 'react';
import { MARRIED_MARITAL_STATUS_ID } from '../../constants';
import { NaturalPerson } from '../../../common/types/client';
import { PolicyCardSectionProps } from '../../../common/components/policyCard/policyCardSection';
import PolicyCard from '../../../common/components/policyCard';

/**
 * Natural person details step
 */
const DetailsStep = ({ client }: ClientStepProps<NaturalPerson>): JSX.Element => {
  return (
    <Box>
      <PolicyCard
        sectionsClassName="grid md:grid-cols-2 gap-6"
        sections={[
          {
            topBorder: false,
            caption: 'Basic',
            items: [
              { name: 'Tax status', value: client.taxStatusNote },
              { name: 'Marital status', value: client.maritalStatusNote },
              { name: 'Phone number', value: client.phones.map(({ number }) => number) },
              { name: 'Email address', value: client.emails.map(({ address }) => address) },
              client.previousSurname && { name: 'Previous surname', value: client.previousSurname },
            ].filter(Boolean) as PolicyCardSectionProps['items'],
          },
          ...(client.maritalStatusID === MARRIED_MARITAL_STATUS_ID
            ? [
                {
                  topBorder: false,
                  caption: 'Spouse details',
                  items: [
                    { name: 'Name', value: `${client.spouseFirstname} ${client.spouseSurname}` },
                    { name: 'Previous surname', value: client.spousePreviousSurname },
                  ],
                },
              ]
            : []),
          {
            topBorder: false,
            caption: 'Addresses',
            items: client.addresses.map(({ street, city, province, country, code, typeNote }) => ({
              name: typeNote,
              value: `${street}, ${city}, ${province}, ${country}, ${code}`,
            })),
          },
        ]}
      />
    </Box>
  );
};

export default DetailsStep;
